import React from "react";

/**
 * Desktop (>=768px) : pastille d'origine (empilé).
 * Mobile (<768px)   : bandeau plein largeur en ligne "Salle 1A",
 *                     tailles fixées en px pour éviter les écarts de scale.
 */
export default function RoomBadge({ salle, className = "", style = {} }) {
  return (
    <div
      className={`
        bg-gradient-to-r from-[#A51A1F] to-[#DB0E16]
        text-white rounded-md
        inline-flex flex-col items-center justify-center
        px-3 py-1
        /* Mobile : pleine largeur + layout horizontal */
        max-[767px]:w-full
        max-[767px]:flex-row
        max-[767px]:justify-center
        max-[767px]:items-center
        max-[767px]:gap-2
        ${className}
      `}
      style={style}
    >
      {/* Libellé */}
      <span
        className="
          font-regular leading-none
          max-[767px]:text-[12px]
          md:text-sm
          text-center
        "
        style={{ lineHeight: 1 }}
      >
        {salle? 'Salle' : 'Pas de salle'}
      </span>

      {/* Code salle */}
      <span
        className="
          font-bold leading-none
          max-[767px]:text-[18px]
          md:text-4xl
        "
        style={{ lineHeight: 1 }}
      >
        {salle}
      </span>
    </div>
  );
}
